import format from 'string-template';

import { realTimeDBPaths, pathPlaceholder } from '../utils/paths';

let isTabVisible = !document.hidden;

document.addEventListener('visibilitychange', () => {
  isTabVisible = !document.hidden;
});

/**
 * Class representing a User's real-time status.
 * This model handles user presence tracking in Firebase Realtime Database.
 *
 * @class UserStatus
 */
class UserStatus {
  constructor(firebase, userId) {
    this.ref = firebase.rtdb.ref(
      format(realTimeDBPaths.USER_STATUS_DOC, {
        [pathPlaceholder.USER_ID]: userId,
      }),
    );
    this.connectedRef = firebase.rtdb.ref('.info/connected');
    this.tabId = this.generateTabId();
    this.tabRef = this.ref.child(`${this.tabId}`);
  }

  /**
   * Generate a unique tab ID for this browser tab
   * @returns {string} Unique tab ID
   */
  generateTabId = () => `tab_${crypto.randomUUID()}`;

  async createTabSession() {
    await this.tabRef.update({
      isOnline: true,
      startTime: Date.now(),
    });
  }

  async removeTabSession() {
    await this.tabRef.remove();
  }

  async trackPresence() {
    const handler = this.connectedRef.on('value', async (snap) => {
      if (!snap.val()) return;

      await this.tabRef.onDisconnect().remove();
      if (isTabVisible) {
        await this.createTabSession();
      }
    });

    return {
      cleanup: () => {
        this.connectedRef.off('value', handler);
        this.removeTabSession();
      },
    };
  }

  // Removed all tab sessions when user logout
  async removeAllTabSessions() {
    await this.ref.remove();
  }
}

export default UserStatus;
